<!--财务中心 供应商快捷结算-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true" size="medium">
          <el-form-item label="供应商：">
            <el-select filterable v-model="searchForm.SUPPLIER_ID" placeholder="请选择" :clearable="true">
              <el-option v-for="item in supplier" :key="item.SUPPLIER_ID" :label="item.NAME" :value="item.SUPPLIER_ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID：">
            <el-input v-model="searchForm.ORDER_ID" placeholder="请输入订单"></el-input>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable>
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select filterable v-model="searchForm.IS_CHECKOUT" placeholder="请选择" :clearable="true">
              <el-option v-for="item in 状态列表" :key="item.ID" :label="item.LABEL" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单备注：">
            <el-input v-model="searchForm.REMARKS" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="doQueryTable()">筛选</el-button>
            <el-button type="primary" plain @click="批量结算()">批量结算</el-button>
            <el-button type="primary" plain @click="printSelectedBill()">导出结算单</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table border stripe show-summary :summary-method="getSummaries" :data="tableData"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="50" min-width="30" label="序号"></el-table-column>
          <el-table-column prop="ORDER_ID" label="订单ID" min-width="100"></el-table-column>
          <el-table-column prop="ORDER_CODE" label="订单编码" min-width="200"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期" min-width="135"></el-table-column>
          <el-table-column prop="SUPPLIER_NAME" label="供应商名称" min-width="135"></el-table-column>
          <el-table-column prop="REAL_TOTAL_GYS_FEE" label="实收总金额（元）" min-width="100"></el-table-column>
          <el-table-column prop="PAPER_FEE" label="纸质金额（元）" min-width="100"></el-table-column>
          <el-table-column prop="RETURN_FEE" label="退货总金额（元）" min-width="100"></el-table-column>
          <el-table-column prop="BILL_FEE" label="结算总金额（元）" min-width="100"></el-table-column>
          <el-table-column prop="REMARKS" label="订单备注" min-width="100"></el-table-column>
          <el-table-column prop="STATUS" label="结算状态" min-width="100">
            <template slot-scope="scope">
              <span style="color: rgb(103, 194, 58);" v-if="scope.row.STATUS == 10">已结算</span>
              <span style="color: #E6A23C;" v-else-if="scope.row.STATUS == 8">已对账</span>
              <span style="color: rgb(245, 108, 108);" v-else>未结算</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="detail(scope.row)">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-check" @click="isSettled(scope.row)"
                v-if="scope.row.STATUS != 10">已结算
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { newSupplierName } from 'api/tcBanlance';
import http from '@/assets/common/http';
import { getActionFun } from '@/assets/api/login';
import util from '@/assets/common/util';
import date from '@/assets/common/date';

export default {
  data() {
    return {
      PAGE_ID: '1150301',
      tableData: [],
      searchForm: {
        SUPPLIER_ID: '',
        DAY_INTERVAL: [date(new Date() - 30 * 24 * 60 * 60 * 1000, '%F'), date(new Date(), '%F')],
      },
      supplier: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      状态列表: [{ ID: '0', LABEL: '未结算' }, { ID: '1', LABEL: '已对账' }, { ID: '2', LABEL: '已结算' }],
      勾选的订单列表: [],

    };
  },
  created() {
    this.querySupplier();
    this.queryBeforeFun();
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.供应商快捷结算筛选记忆 && this.供应商快捷结算筛选记忆.CONDITION && this.供应商快捷结算筛选记忆.CURRENT_PAGE) {
      this.searchForm = this.供应商快捷结算筛选记忆.CONDITION;
      this.currentPage = this.供应商快捷结算筛选记忆.CURRENT_PAGE;
      this.queryData();
    } else {
      this.currentPage = 1;
    }
  },
  computed: {
    供应商快捷结算筛选记忆() {
      return this.$store.state.供应商快捷结算筛选记忆;
    },
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if ([6, 7, 8, 9].includes(index)) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return Math.floor((prev + value) * 100) / 100;
            }
            return prev;
          }, 0);
        } else {
          sums[index] = '---';
        }
      });
      this.sums = sums;
      return sums;
    },
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    handleCurrentChange() {
      this.queryData();
    },
    // -------------------------------搜索
    doQueryTable() {
      this.currentPage = 1;
      this.queryData();
    },
    // -------------------------------查询供应商结算
    queryData() {
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
        SERVICE_ID: '10026',
        OTYPE: 36,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      if (this.searchForm.DAY_INTERVAL && this.searchForm.DAY_INTERVAL[0]) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      if (this.searchForm.IS_CHECKOUT) {
        params.IS_CHECKOUT = this.searchForm.IS_CHECKOUT;
      }
      if (this.searchForm.REMARKS) {
        params.REMARKS = this.searchForm.REMARKS;
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      http.post(params).then((result) => {
        if (result) {
          this.tableData = result.DATA;
          this.totalCount = result.TOTAL;
          this.$store.dispatch('保存供应商快捷结算筛选记忆', {
            CONDITION: this.searchForm,
            CURRENT_PAGE: this.currentPage,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -----------------------------------获取供应商
    querySupplier() {
      const params = {};
      if (this.searchForm.supplier_name) {
        params.SUPPLIER_NAME = this.searchForm.supplier_name;
      }
      newSupplierName(params).then((res) => {
        if (res.length !== 0) {
          this.supplier = res[0].list;
        } else {
          this.supplier = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // -----------------------查看每日订单详情
    detail(row) {
      this.$router.push({ path: '/supplierDayList/detail' });
      sessionStorage.setItem('ORDER_ID', row.ORDER_ID);
    },
    isSettled(row) {
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 20,
        ORDER_ID: row.ORDER_ID,
      };
      http.post(params).then((res) => {
        if (res.length == 0) {
          this.$message.show({ text: '结算状态更新成功', type: 'success' });
          this.queryData();
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    handleSelectionChange(val) {
      this.勾选的订单列表 = val;
    },
    printSelectedBill() {
      if (this.勾选的订单列表.length == 0) {
        this.$message.show({ text: '请先勾选要导出的结算单', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 19,
        ORDER_ID_LIST: this.勾选的订单列表.map(({ ORDER_ID }) => ORDER_ID),
      };
      http.post(params).then((res) => {
        if (res[0] && res[0].FILE_PATH) {
          window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    批量结算() {
      if (this.勾选的订单列表.length == 0) {
        this.$message.show({ text: '请勾选需要结算的订单', type: 'warning' });
        return false;
      }
      if (this.勾选的订单列表.some(({ STATUS }) => STATUS == 10)) {
        this.$message.show({ text: '勾选订单存在已结算订单，请重新勾选', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10026',
        OTYPE: 20,
        ORDER_ID: this.勾选的订单列表.map(({ ORDER_ID }) => ORDER_ID),
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/financeCenter/supplierQuickBalance.vue